var map = {
	"./affix/style/index.ts": "./components/affix/style/index.ts",
	"./alert/style/index.ts": "./components/alert/style/index.ts",
	"./anchor/style/index.ts": "./components/anchor/style/index.ts",
	"./app/style/index.ts": "./components/app/style/index.ts",
	"./avatar/style/index.ts": "./components/avatar/style/index.ts",
	"./back-top/style/index.ts": "./components/back-top/style/index.ts",
	"./badge/style/index.ts": "./components/badge/style/index.ts",
	"./breadcrumb/style/index.ts": "./components/breadcrumb/style/index.ts",
	"./button/style/index.ts": "./components/button/style/index.ts",
	"./calendar/style/index.ts": "./components/calendar/style/index.ts",
	"./card/style/index.ts": "./components/card/style/index.ts",
	"./carousel/style/index.ts": "./components/carousel/style/index.ts",
	"./cascader/style/index.ts": "./components/cascader/style/index.ts",
	"./checkbox/style/index.ts": "./components/checkbox/style/index.ts",
	"./col/style/index.ts": "./components/col/style/index.ts",
	"./collapse/style/index.ts": "./components/collapse/style/index.ts",
	"./color-picker/style/index.ts": "./components/color-picker/style/index.ts",
	"./config-provider/style/index.ts": "./components/config-provider/style/index.ts",
	"./date-picker/style/index.ts": "./components/date-picker/style/index.ts",
	"./descriptions/style/index.ts": "./components/descriptions/style/index.ts",
	"./divider/style/index.ts": "./components/divider/style/index.ts",
	"./drawer/style/index.ts": "./components/drawer/style/index.ts",
	"./dropdown/style/index.ts": "./components/dropdown/style/index.ts",
	"./empty/style/index.ts": "./components/empty/style/index.ts",
	"./float-button/style/index.ts": "./components/float-button/style/index.ts",
	"./form/style/index.ts": "./components/form/style/index.ts",
	"./grid/style/index.ts": "./components/grid/style/index.ts",
	"./image/style/index.ts": "./components/image/style/index.ts",
	"./input-number/style/index.ts": "./components/input-number/style/index.ts",
	"./input/style/index.ts": "./components/input/style/index.ts",
	"./layout/style/index.ts": "./components/layout/style/index.ts",
	"./list/style/index.ts": "./components/list/style/index.ts",
	"./mentions/style/index.ts": "./components/mentions/style/index.ts",
	"./menu/style/index.tsx": "./components/menu/style/index.tsx",
	"./message/style/index.tsx": "./components/message/style/index.tsx",
	"./modal/style/index.tsx": "./components/modal/style/index.tsx",
	"./notification/style/index.tsx": "./components/notification/style/index.tsx",
	"./pagination/style/index.ts": "./components/pagination/style/index.ts",
	"./popconfirm/style/index.tsx": "./components/popconfirm/style/index.tsx",
	"./popover/style/index.tsx": "./components/popover/style/index.tsx",
	"./progress/style/index.tsx": "./components/progress/style/index.tsx",
	"./qrcode/style/index.ts": "./components/qrcode/style/index.ts",
	"./radio/style/index.tsx": "./components/radio/style/index.tsx",
	"./rate/style/index.tsx": "./components/rate/style/index.tsx",
	"./result/style/index.tsx": "./components/result/style/index.tsx",
	"./row/style/index.tsx": "./components/row/style/index.tsx",
	"./segmented/style/index.tsx": "./components/segmented/style/index.tsx",
	"./select/style/index.tsx": "./components/select/style/index.tsx",
	"./skeleton/style/index.tsx": "./components/skeleton/style/index.tsx",
	"./slider/style/index.tsx": "./components/slider/style/index.tsx",
	"./space/style/index.tsx": "./components/space/style/index.tsx",
	"./spin/style/index.tsx": "./components/spin/style/index.tsx",
	"./statistic/style/index.tsx": "./components/statistic/style/index.tsx",
	"./steps/style/index.tsx": "./components/steps/style/index.tsx",
	"./switch/style/index.ts": "./components/switch/style/index.ts",
	"./table/style/index.ts": "./components/table/style/index.ts",
	"./tabs/style/index.ts": "./components/tabs/style/index.ts",
	"./tag/style/index.ts": "./components/tag/style/index.ts",
	"./timeline/style/index.ts": "./components/timeline/style/index.ts",
	"./tooltip/style/index.ts": "./components/tooltip/style/index.ts",
	"./tour/style/index.ts": "./components/tour/style/index.ts",
	"./transfer/style/index.ts": "./components/transfer/style/index.ts",
	"./tree-select/style/index.ts": "./components/tree-select/style/index.ts",
	"./tree/style/index.ts": "./components/tree/style/index.ts",
	"./typography/style/index.ts": "./components/typography/style/index.ts",
	"./upload/style/index.ts": "./components/upload/style/index.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components sync recursive ^\\.\\/[^_][\\w-]+\\/style\\/index\\.tsx?$";